import { render, staticRenderFns } from "./screenTutoriales.vue?vue&type=template&id=a27b7446"
import script from "./screenTutoriales.vue?vue&type=script&lang=js"
export * from "./screenTutoriales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports